// Module
var code = `<div appHeaderBar>
    <header-bar-title>Edit Schedule</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form *ngIf="doneLoading"
          name="scheduleDetailEdit"
          id="scheduleDetailEdit"
          tid="scheduleDetailEdit"
          #scheduleDetailEditForm="ngForm">
        <div class="HOA-container">
            <div class="HOA-container__header">
                <div class="HOA-container__header-text" tid="scheduleNicknameHeader">
                    Edit One-Time Payment
                </div>
            </div>
            <div class="HOA-container__content">
                <!--Nickname-->
                <div [ngClass]="{ 'is-invalid': scheduleNicknameError }" class="Field">
                    <label class="Field-label">
                        Payment Name
                        <span class="asterisk-required">&nbsp;&#42;</span>
                    </label>
                    <input type="text"
                           class="Input"
                           id="scheduleNickname"
                           name="scheduleNickname"
                           tid="scheduleNickname"
                           maxlength="50"
                           [(ngModel)]="currentNickname"
                           (change)="scheduleNicknameChange()"
                           (blur)="scheduleNicknameBlur()"
                           [attr.aria-invalid]="scheduleNicknameError"
                           [attr.aria-describedby]="scheduleNicknameError && 'scheduleNickname-error' || undefined">
                    <span class="Field-error" tid="scheduleNickname-error" id="scheduleNickname-error">
                                Please give your schedule a valid nickname.
                            </span>
                </div>

                <!--Payment Method-->
                <div [ngClass]="{ 'is-invalid': paymentMethodError }" class="Field">
                    <label class="Field-label" for="paymentMethod">
                        Payment Method
                        <span class="asterisk-required">&nbsp;&#42;</span>
                    </label>
                    <div class="Select">
                        <select tid="paymentMethod"
                                id="paymentMethod"
                                name="paymentMethod"
                                [attr.aria-invalid]="paymentMethodError"
                                [attr.aria-describedby]="paymentMethodError && 'paymentMethod-error' || undefined"
                                [(ngModel)]="currentPaymentMethod"
                                (change)="onChangePmtMethod()">
                            <option *ngFor="let paymentMethod of paymentMethods"  [ngValue]="paymentMethod">
                                {{((paymentMethod.nickname) ? paymentMethod.nickname : paymentMethod.line1) + ' (' + paymentMethod.maskedId + ')'}}
                            </option>
                        </select>
                        <span class="Select-arrow"></span>
                    </div>
                    <span tid="paymentMethod-error" id="paymentMethod-error" class="Field-error">
                                {{paymentMethodErrorMsg ? paymentMethodErrorMsg : "Please select a payment method."}}
                            </span>
                    <span tid="paymentMethodMessage" id="paymentMethodMessage" class="HOA-Field-detail">
                                {{ (currentPaymentMethod && currentPaymentMethod.routingNumber)? ACHMessage : "" }}
                            </span>
                </div>
                <div class="HOA-flextable-component__cell--50"></div>

                <!-- SCHEDULE AMOUNT SECTION STARTS - ONLY FOR FIXED AMOUNT SCHEDULES -->
                <div class="HOA-misc-guidedSteps__flex-padded">

                    <!--fixed day-->
                    <div class="HOA-flex-component HOA-make-payment-item-row--top-justified" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            Payment Date
                        </div>
                        <app-mat-date-picker
                                [tidValue]="'schedulepaymentDate'"
                                [idValue]="'schedulepaymentDate'"
                                *ngIf="paymentDatePickerConfig"
                                [required]="true"
                                [config]="paymentDatePickerConfig"
                                (onDateChange)="paymentDateChange(\$event)">
                        </app-mat-date-picker>
                    </div>
                    <br>
                    <div class="HOA-flex-component HOA-make-payment-item-row--top-justified">
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            <!-- single row in dues -->
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="amountSingleDueLabel">
                                    Amount
                                    <span class="asterisk-required">&nbsp;&#42;</span>
                                </label>
                                <span class="HOA-Field-detail">(Enter amount to be paid in box)</span>
                            </div>
                        </div>
                        <div [ngClass]="{ 'is-invalid': isDueAmountInvalid(amountToPay) }"
                             class="Field u-cf HOA-make-payment-item-row-amount">
                            <div class="Field-addonBox ">
                                <input id="amount1"
                                       name="amount1"
                                       tid="amountSingleDue"
                                       type="text"
                                       class="Input"
                                       [(ngModel)]="amountToPay"
                                       (focus)="clearAmountFieldWhen0(amountToPay)"
                                       (change)="updateAmount()"
                                       [attr.aria-invalid]="isDueAmountInvalid(amountToPay)"
                                       [attr.aria-describedby]="isDueAmountInvalid(amountToPay) && 'amount1-error' || undefined"
                                       maxlength="9"
                                       custom-currency />
                                <button tid="amountSingleClearButton"
                                        type="button"
                                        class="Field-addon"
                                        (click)="clearDue()"
                                        aria-label="Click to clear payment amount">
                                    x
                                </button>
                            </div>
                            <span id="amount1-error" tid="amountSingleError" class="Field-error">
                                        {{amountToPayErrorMsg ? amountToPayErrorMsg : "Please enter an amount."}}
                                    </span>
                        </div>
                    </div>

                    <!--Administrative fee-->
                    <div class="HOA-flex-component HOA-make-payment-item-row" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="convenienceFeeLabel">
                                    Administrative Fee
                                </label>
                            </div>
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                            <span tid="convenienceFeeAmount">{{currentConvenienceFee | currency}}</span>
                        </div>
                    </div>

                    <!--Amount to be paid-->
                    <div class="HOA-flex-component HOA-make-payment-item-row" >
                        <div class="HOA-flex-component HOA-make-payment-flex-align HOA-make-payment-fancy-width u-pT3">
                            <div class="HOA-make-payment-flex HOA-make-payment-item-row-details">
                                <label tid="amountToBePaidLabel">
                                    Amount to be paid
                                </label>
                            </div>
                        </div>
                        <div class="Field-addonBox HOA-make-payment-item-row-amount u-textCenter">
                                    <span tid="amountToBePaid"
                                          class="HOA-make-payment-amount-owed">
                                        {{amountToPayErrorMsg ? 'n/a' : totalAmount | currency}}
                                    </span>
                        </div>
                    </div>
                </div>
                <!-- SCHEDULE AMOUNT SECTION ENDS - ONLY FOR FIXED AMOUNT SCHEDULES -->

                <div class="u-pT5">
                    <input type="checkbox"
                           id="tcCheckbox"
                           name="tcCheckbox"
                           tid="tcCheckbox"
                           class="Field u-cf"
                           style="margin-bottom: 26px; accent-color: #00505c"
                           [(ngModel)]="tcCheckbox"
                           [ngClass]="{'is-invalid': false}">
                    <label for="tcCheckbox" class="HOA-font-light">
                        I agree to pay the total amount including any fees as shown above.
                    </label>
                </div>

                <div class="HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="cancel"
                            tid="cancel"
                            type="button"
                            class="Button Button--link "
                            (click)="cancel()">
                        Back
                    </button>
                    <button name="submitSave"
                            id="submitSave"
                            tid="submitSave"
                            type="submit"
                            class="Button Button--blue "
                            [disabled]="submitDisabled()"
                            (click)="save()">
                        Save
                    </button>
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                    <span class="asterisk-required">&#42;</span>
                    &nbsp;Indicates required field
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                    <span class="asterisk-required">&#42;</span>
                    &nbsp;Payment Dates that fall on weekends or holidays will be paid the business day prior.
                </div>
            </div>
            <div class="HOA-remove-button-container">
                <div>
                    <button name="deleteSchedule"
                        id="deleteSchedule"
                        tid="deleteSchedule"
                        type="button"
                        class="Button Button--link"
                        (click)="removeSchedule()">
                            Cancel Payment
                    </button>
                </div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;